<button
  #optionRef
  class="bg-white py-[15px] px-3 cursor-pointer w-full text-left text-sm tablet:text-base font-light"
  (click)="select()"
  [class.text-[#ababab]]="isSelected"
  role="option"
  [attr.aria-selected]="isSelected"
>
  <ng-content></ng-content>
</button>
